<script setup lang="ts">
interface Props {
  code: string
  title?: string
  size?: 'sm' | 'md' | 'lg'
  country?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  title: undefined,
  size: 'md',
  country: false
})

const sizeClasses = {
  sm: 'size-5',
  md: 'size-6',
  lg: 'size-7'
}

const sizeValues = {
  sm: { width: 20, height: 20 },
  md: { width: 24, height: 24 },
  lg: { width: 28, height: 28 }
}
</script>

<template>
  <NuxtImg
    :src="
      useAsset(
        props.country
          ? `/images/flags/country/2x/${props.code?.toLowerCase() || 'default'}.png`
          : `/images/flags/${props.code?.toLowerCase() || 'default'}-kgs.png`
      )
    "
    :alt="`${$t('ui.currency_icon.flag_alt')} ${props.title || props.code}`"
    :width="sizeValues[props.size].width"
    :height="sizeValues[props.size].height"
    :class="sizeClasses[props.size]"
    loading="lazy"
  />
</template>
